export default __webpack_public_path__ + "static/media/elevadoreslingaparatambores.de7f7857.png";